<template>
  <div class="about">
    <Head></Head>
    <div class="banner">
      <div class="musk">
       <h4 class="css1a8429752e20234">主营业务</h4>
       <p style="width:850px;margin:60px auto;text-align:left">
        湖南红杏林科技有限公司致力于为寻医之人提供绿色健康的调理方案，为学医之人提供临床有效的中医技术，
        为传医之人提供分享共赢的服务平台，为中医梦、健康中国梦贡献自己的力量。<br><br>
        主营业务：教学设备的研究。软件、图书数据处理技术的开发。
        教学仪器电控教学实训设备。文化用品、计算机软件
        ，电子和数字出版物、出版物的销售:电化教学设备的维修
        维护:信息技术测评服务:文艺表演、体育、娱乐活动的策划
        和组织:形像设备研发:健康养生咨询(不含医疗诊断):培训
        活动的组织:中医药文化推广:会议，展览及相关服务，信息
        技术咨询服务:教育咨询:文化活动服务:企业管理咨询服务:
        计算机技术咨询:广告设计:广告制作服务:广告国内外代理
        服务:广告发布服务，文化活动的组织与策划。(依法须经批准
        的项目，经相关部门批准后方可开展经营活动)
      </p>
      </div>
    </div>
    <!-- <div class="des">
      <p>
        主营业务：教学设备的研究。软件、图书数据处理技术的开发。
        教学仪器电控教学实训设备。文化用品、计算机软件
        ，电子和数字出版物、出版物的销售:电化教学设备的维修
        维护:信息技术测评服务:文艺表演、体育、娱乐活动的策划
        和组织:形像设备研发:健康养生咨询(不含医疗诊断):培训
        活动的组织:中医药文化推广:会议，展览及相关服务，信息
        技术咨询服务:教育咨询:文化活动服务:企业管理咨询服务:
        计算机技术咨询:广告设计:广告制作服务:广告国内外代理
        服务:广告发布服务，文化活动的组织与策划。(依法须经批准
        的项目，经相关部门批准后方可开展经营活动)
      </p>
    </div> -->

    <!-- <div class="wrap">
      <div class="content">
        <div class="card" :class="{ hidden: !isIE, show: show1 }">
          <div class="title">
            <div class="circel"></div>
            <h3 class="css1a8429752e20234">使命</h3>
          </div>
          <div class="flex">
            <div class="fill"></div>
            <div class="text">
              <h4 class="css1a8429752e20234">
                一颗<span class="color">红心</span> 只为照亮<span class="color"
                  >杏林</span
                >
              </h4>
              <p class="p">“<span class="color">红</span>”字三解：</p>
              <p>
                红尘百姓
                <span class="zhehao"></span> 让有效的中医真正造福于百姓<br />
                良心良知
                <span class="zhehao"></span> 我们从事的是一份有良心的事业<br />
                红火红旺
                <span class="zhehao"></span> 尽一切努力让中医红火红旺起来
              </p>
            </div>
          </div>
          <img class="absolute" src="../assets/about_img1.png" alt="" />
          <img class="seal" src="../assets/about_img2.png" alt="" />
        </div>

        <div class="card" :class="{ hidden: !isIE, show: show2 }">
          <div class="title">
            <div class="circel"></div>
            <h3 class="css1a8429752e20234">愿景</h3>
          </div>

          <div class="text">
            <h4 class="css1a8429752e20234">
              致力于成为中医大健康领域受人尊重的综合性服务平台<br />成为中医大健康领域领导品牌
            </h4>
            <p>
              不论时代如何发展，健康永远是人心深处最真实的渴望。<br />
              作为“实施健康中国战略”的重要板块，中医药产业发展已经上升为国家战略。
            </p>
            <p>
              我们秉承“为中医崛起而奋斗”的事业初心，<br />
              专注以互联网核心能力推动国粹中医的传承与传播，<br />
              并将社会责任融入每一个项目产品和活动，真正让优秀的中医疗法造福于百姓生活，<br />
              进而成为无数中医人快速学习和成长的综合服务平台。
            </p>
          </div>

          <img class="seal" src="../assets/about_img2.png" alt="" />
        </div>

        <div class="card">
          <div class="title">
            <div class="circel"></div>
            <h3 class="css1a8429752e20234">团队与文化</h3>
          </div>

          <div class="text">
            <h4 class="css1a8429752e20234">投资、付出、极致、感恩</h4>
            <p>
              中医之崛起，任重而道远。可能需要我们一代人甚至几代人共同的努力，倾尽毕生心血。
            </p>
            <p>
              在这里，我们拥有一支优秀的运营团队，这是一群年轻而朝气蓬勃，专业而胸怀远大的互联网+中医创业者，不仅具备多年互联网创业成功经验，更对中医有着近乎狂热的执着追求。
            </p>
            <p>
              自成立伊始，我们始终注重对每一个伙伴的专业培养，投资、付出、极致、感恩，真正帮助每一个伙伴获得能力上的成长、物质上的肯定、精神上的富足、事业上的成功。因为我们深知，只有更优秀的伙伴才能为用户提供更优质的产品和服务，进而成就更美好的未来。
            </p>
          </div>

          <div class="preview">
            <div class="imgs">
              <img
                v-for="(item, index) in imgs"
                :class="{ active: active == index }"
                :src="item"
                :key="index"
              />
            </div>
            <div class="left" @click="goLeft">
              <img src="../assets/left.png" alt="" />
            </div>
            <div class="right" @click="goRight">
              <img src="../assets/right.png" alt="" />
            </div>
          </div>

          <ul class="imgs">
            <li
              class="img"
              :class="{ active: active === index }"
              v-for="(item, index) in imgs"
              @click="switchImg(index)"
              :key="index"
            >
              <img :src="item" />
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <Foot></Foot>
  </div>
</template>

<script>
import store from "@/store";

import Head from "@/components/Head.vue";
import Foot from "@/components/Foot.vue";
import team1 from "@/assets/team1.jpg";
import team2 from "@/assets/team2.jpg";
import team3 from "@/assets/team3.jpg";
import team4 from "@/assets/team4.jpg";
import team5 from "@/assets/team5.jpg";
import team6 from "@/assets/team6.jpg";
import team7 from "@/assets/team7.jpg";
import team8 from "@/assets/team8.jpg";

export default {
  name: "about",
  data() {
    return {
      imgs: [team1, team2, team3, team4, team5, team6, team7, team8],
      active: 0,
      timer: null,
      show1: false,
      show2: false,
      isIE: false,
    };
  },
  components: {
    Head,
    Foot,
  },
  mounted() {
    this.isIE = this.$isIE;
    this.loop();
  },
  methods: {
    switchImg(index) {
      this.active = index;
      clearInterval(this.timer);
      this.loop();
    },
    loop() {
      this.timer = setInterval(() => {
        if (this.active < this.imgs.length - 1) {
          this.active++;
        } else {
          this.active = 0;
        }
      }, 2000);
    },
    goLeft() {
      if (this.active == 0) {
        this.active = this.imgs.length;
      }
      this.active--;
      clearInterval(this.timer);
      this.loop();
    },
    goRight() {
      if (this.active == this.imgs.length - 1) {
        this.active = -1;
      }
      this.active++;
      clearInterval(this.timer);
      this.loop();
    },
  },
  computed: {
    scrollTop() {
      return store.state.scrollTop;
    },
  },
  watch: {
    scrollTop: function (value, oldvalue) {
      if (value > 0) {
        this.show1 = true;
      }
      if (value > 700) {
        this.show2 = true;
      }
    },
  },
};
</script>
<style scoped>
.banner {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  height: 744px;
  background: #a53b45 url(../assets/about_bg1.jpg) no-repeat center bottom;
}
.banner .musk {
  position: absolute;
  top: 50%;
  margin-top: -250px;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
}
.banner h4 {
  font-size: 34px;
  font-weight: bold;
}
.banner p {
  margin-top: 50px;
}
.wrap {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 70px 0;
  background: url(../assets/about_bg2.jpg) no-repeat center 360px;
}
.card {
  max-width: 1165px;
  background: #fff;
  padding: 46px;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 70px;
  height: 630px;
}
.card .seal {
  position: absolute;
  bottom: 46px;
  right: 46px;
  width: 62px;
}
.card .absolute {
  position: absolute;
  bottom: 27px;
  left: 40px;
  max-width: 592px;
}
.card .title {
  position: absolute;
  top: 60px;
  left: 60px;
  width: 40px;
  font-size: 38px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 10px;
}
.card .title .circel {
  width: 20px;
  height: 20px;
  border: 3px solid #9d2933;
  box-sizing: border-box;
  border-radius: 50%;
  margin: 0 auto 14px;
}
.card:nth-child(1) .text {
  width: 530px;
}
.card .text {
  margin-top: 80px;
  margin-left: 180px;
}
.card h4 {
  font-size: 24px;
  margin-bottom: 50px;
  line-height: 50px;
}
.card .p {
  margin-bottom: 20px;
}
.card p {
  margin-bottom: 30px;
}
.card:nth-child(3) {
  background: #9d2933;
  color: #fff;
  height: auto;
}
.card:nth-child(3) .circel {
  border-color: #fff;
}
.card:last-child {
  margin-bottom: 0;
}
.preview {
  margin-top: 80px;
  position: relative;
  padding-bottom: 52%;
}
.preview .imgs {
  position: relative;
  height: 100%;
}
.preview .imgs img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: 1s;
}
.preview .left,
.preview .right {
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  padding: 20px;
  top: 226px;
  cursor: pointer;
}
.preview .left {
  left: 20px;
}
.preview .right {
  right: 20px;
}
.preview .left img,
.preview .right img {
  width: 36px;
}
.preview img.active {
  opacity: 1;
}
.imgs {
  margin-top: 28px;
  margin-left: -5px;
  margin-right: -5px;
  display: flex;
}
.img {
  width: 124px;
  height: 86px;
  margin: 0 5px;
  opacity: 0.6;
  display: inline-block;
}
.img img {
  width: 124px;
  height: 64px;
}
.active {
  opacity: 1;
}
.zhehao {
  color: #9da2a8;
  width: 30px;
  background: #9da2a8;
  height: 1px;
  display: inline-block;
  vertical-align: middle;
}
.des {
  padding: 50px;
  max-width: 1920px;
}
</style>

